import { makeAutoObservable } from 'mobx';
import {endpoints, types} from 'main/tools';
import {DomainStore} from 'shared/store';
import {InterviewGuide} from 'main/stores/interview_guides';

class InterviewGuideState {
  store = new DomainStore();
  history;

  interviewGuides = [];
  errors = {};

  constructor(history) {
    makeAutoObservable(this, {
      store: false,
      history: false
    });

    this.history = history;
  }

  async load() {
    await this.store._compose([
      endpoints.INTERVIEW_GUIDES
    ]);

    this.interviewGuides = this.store._getAll(types.INTERVIEW_GUIDE, InterviewGuide);
  }

  async deleteInterviewGuide(model) {
    await this.store.destroy(model);
    await this.load();
  }
}

export default InterviewGuideState;
